module.exports = __webpack_public_path__ + "img/google.0de8c058.1d4511b6.png";